function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iott");

var SvgIott01 = function SvgIott01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 163.336 110",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 29.335,
    cy: 76.972,
    r: 3.356,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.714,
    y1: 49.758,
    x2: 54.73,
    y2: 53.21,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.818,
    y1: 15.223,
    x2: 46.643,
    y2: 57.302,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.093,
    y1: 14.739,
    x2: 62.891,
    y2: 40.201,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.737,
    y1: 19.475,
    x2: 90.175,
    y2: 40.477,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.314,
    y1: 19.78,
    x2: 71.035,
    y2: 36.263,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.165,
    y1: 102.771,
    x2: 137.195,
    y2: 38.469,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.504,
    y1: 99.923,
    x2: 86.843,
    y2: 20.039,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.203,
    y: 74.103,
    width: 0.351,
    height: 16.445,
    style: {
      fill: "#c3b5cb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.203,
    y: 47.266,
    width: 0.351,
    height: 24.557,
    style: {
      fill: "#c3b5cb",
      stroke: "#633a69",
      strokeMiterlimit: 10,
      strokeWidth: "0.27525776292489523px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.203,
    y: 13.238,
    width: 0.351,
    height: 24.557,
    style: {
      fill: "#c3b5cb",
      stroke: "#633a69",
      strokeMiterlimit: 10,
      strokeWidth: "0.27525776292489523px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.378,
    cy: 74.103,
    r: 4.385,
    style: {
      fill: "#c3b5cb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.378,
    cy: 44.811,
    r: 8.244,
    style: {
      fill: "#c3b5cb",
      stroke: "#633a69",
      strokeMiterlimit: 10,
      strokeWidth: "0.27525776292489523px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.378,
    cy: 13.238,
    r: 11.05,
    style: {
      fill: "#c3b5cb",
      stroke: "#633a69",
      strokeMiterlimit: 10,
      strokeWidth: "0.27525776292489523px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.993,
    cy: 8.327,
    r: 1.754,
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.009,
    cy: 12.185,
    r: 1.052,
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.378,
    cy: 17.798,
    r: 1.052,
    style: {
      fill: "#d0cde1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.342,79.115a17.665,17.665,0,0,1-17.43,17.892c-.146,0-.3,0-.45-.012v.012H51.275a20.76,20.76,0,1,1,0-41.521q.638,0,1.276.036A23.7,23.7,0,0,1,99.1,51.038a13.81,13.81,0,0,1,1.75-.109A14.794,14.794,0,0,1,114.99,61.369,17.718,17.718,0,0,1,130.342,79.115Z",
    style: {
      fill: "#f0b4b9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.818,
    cy: 15.223,
    r: 3.038,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.165,
    cy: 102.771,
    r: 4.112,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.407,
    cy: 76.972,
    r: 3.403,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.504,
    cy: 99.923,
    r: 2.848,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.988,
    cy: 19.278,
    r: 4.055,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.647,
    cy: 48.636,
    r: 2.331,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.561,
    cy: 38.102,
    r: 1.956,
    style: {
      fill: "#95719b"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.669,
    y1: 49.758,
    x2: 33.818,
    y2: 15.223,
    style: {
      fill: "#95719b",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.818,
    y1: 15.223,
    x2: 86.843,
    y2: 20.039,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.669,
    y1: 49.758,
    x2: 28.702,
    y2: 76.339,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.165,
    y1: 104.756,
    x2: 28.702,
    y2: 76.339,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.669,
    y1: 49.758,
    x2: 21.165,
    y2: 102.771,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.227,
    y1: 18.851,
    x2: 137.195,
    y2: 38.469,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.407,
    y1: 76.265,
    x2: 137.195,
    y2: 38.469,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134.504,
    y1: 99.923,
    x2: 150.407,
    y2: 76.265,
    style: {
      fill: "none",
      stroke: "#95719b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5505155258497905px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.899 70.664 80.8 56.12 74.653 61.137 74.653 59.104 69.238 59.104 69.238 65.555 62.979 70.664 65.782 70.664 65.782 87.126 96.096 87.126 96.096 70.664 98.899 70.664",
    style: {
      fill: "#95719b",
      stroke: "#633a69",
      strokeMiterlimit: 10,
      strokeWidth: "1.101031051699581px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.899 70.664 80.8 56.12 74.653 61.137 74.653 59.104 69.238 59.104 69.238 65.555 62.979 70.664 65.782 70.664 65.782 87.126 96.096 87.126 96.096 70.664 98.899 70.664",
    style: {
      fill: "#de3f41"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.255,
    cy: 81.911,
    r: 1.583,
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.973,69.5a10.627,10.627,0,0,0-7.789,2.751.834.834,0,0,1-1.138-.012l-.929-.885a.837.837,0,0,1-.029-1.183l.04-.039a13.612,13.612,0,0,1,18.78.319.838.838,0,0,1,.008,1.185l-.039.037-.959.853a.833.833,0,0,1-1.134-.022A10.622,10.622,0,0,0,81.973,69.5Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.877,71.136a10.621,10.621,0,0,1,6.717,2.909.836.836,0,0,1,.026,1.181q-.024.025-.049.048l-.715.636a.834.834,0,0,1-1.124-.013,8.037,8.037,0,0,0-10.745-.186.837.837,0,0,1-1.128-.021l-.693-.659a.834.834,0,0,1-.033-1.18q.023-.025.049-.047A10.626,10.626,0,0,1,81.877,71.136Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5,77.524a5.888,5.888,0,0,0-4.07,1.315.843.843,0,0,1-1.118-.033l-.335-.319a.838.838,0,0,1,.047-1.253,8.037,8.037,0,0,1,10.491.194.832.832,0,0,1-.014,1.237l-.346.309a.843.843,0,0,1-1.118-.006A5.881,5.881,0,0,0,81.5,77.524Z",
    style: {
      fill: "#fcfcfc"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.323,
    cy: 102.771,
    rx: 45.44,
    ry: 4.112,
    style: {
      fill: "#ca8998"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIott01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iott-01.64be2de9.svg";
export { ForwardRef as ReactComponent };